// Single source of truth para env vars en runtime.
// Migrado de `process.env.REACT_APP_*` (CRA) a `import.meta.env.VITE_*` (Vite).
// Si necesitas leer una env var en código, importá `env` desde acá — no leas `import.meta.env` directo.

export const env = {
  API_URL: (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:5001',
  GOOGLE_MAPS_API_KEY: (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ?? '',
  GOOGLE_CLIENT_ID: (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined) ?? '',
} as const;
